import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Img } from "arv-reactcomponents";
import { ORDERDETAILS, footerUrls, Endpoints } from "npmlinks-constants";

import Anchor from "../../Anchor";

const { ORDER_DETAILS: { ORDERDETAILS_FOOTER } } = ORDERDETAILS;

@inject("CommonStore")
@observer
class OrderDetailsFooter extends Component {
  get imgUrl() {
    const { isDesktop } = this.props.CommonStore;

    return isDesktop
      ? Endpoints.orderdetailsFooter
      : Endpoints.orderdetailsMobileFooter;
  }

  render() {
    return (
      <div className="nw-orderdetailspage-footer">
        <div className="nw-orderdetailspage-footercontent">
          <Img className="nw-orderdetailspagefooter-image" src={this.imgUrl} />
          <div className="nw-orderdetailspage-footertext">
            {ORDERDETAILS_FOOTER.MESSAGE}
          </div>
          <div className="nw-orderdetailspage-contactus">
            <Anchor.component
              target="_self"
              id="nw-footer-nav-links-contactus"
              className="nw-orderdetailsfooter-contactus"
              href={footerUrls.contactus}
              to={footerUrls.contactus}
            >
              {ORDERDETAILS_FOOTER.CONTACT_US}
            </Anchor.component>
          </div>
        </div>
      </div>
    );
  }
};

OrderDetailsFooter.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: OrderDetailsFooter.wrappedComponent,
  component: OrderDetailsFooter,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderDetailsComponents/OrderDetailsFooter/index.js